import { useTitleChange } from '@msaf/core-react'
import YieldDrawDownWrapper from '../../../../components/well-forms/drilling-tests/drilling-test-wrapper'

export default function ViewWellDrillingTests() {
  useTitleChange('View Well | Yield drawdown tests')
  return <YieldDrawDownWrapper isViewMode />
}
